import {load} from '../../apis/persist'
import {actionTypes} from '../actions/location'

// Reducer

const initialState = {
  latitude: Number(load('latitude')) || undefined,
  longitude: Number(load('longitude')) || undefined,
  postcode: Number(load('postcode')) || undefined,
  state: load('state') || '',
  locality: load('locality') || '',
  locationConfirmed: load('locationConfirmed') === 'true',
  isFetching: false,
  fetchError: '',
  postcodePopupOpen: false,
}

export default function location(state = initialState, {type, payload} = {}) {
  switch(type) {
    case actionTypes.LOCATION_FETCH_START:
      return {...state, fetchError: '', isFetching: true}
    case actionTypes.LOCATION_FETCH_ERROR:
      return {...state, fetchError: payload.error, isFetching: false}
    case actionTypes.LOCATION_FETCH_SUCCESS:
      return {
        ...state, ...payload, fetchError: '', isFetching: false,
      }
    case actionTypes.POSTCODE_POPUP_SHOW:
      return {...state, postcodePopupOpen: true}
    case actionTypes.POSTCODE_POPUP_HIDE:
      return {...state, postcodePopupOpen: false}
    case actionTypes.LOCATION_CONFIRMED:
      return {...state, locationConfirmed: true}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/location.js